<template>
  <div>
    <v-card width="6000">
      <v-card-title>
        <DialogTitle :dialogName="$options.name">
          Measure Types
        </DialogTitle>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :items-per-page="10"
          :footer-props="{
            'show-first-last-page': true
          }"
          :headers="headers"
          :items="infoList"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.IsRequired="{ item }">
            <v-icon v-if="item.IsRequired" color="green">
              {{ icon.checkMark }}
            </v-icon>
          </template>
          <template v-slot:item.Actions="{ item }">
            <v-icon small class="mr-2" @click="editItemClick(item)">
              {{ icon.lineItemEdit }}
            </v-icon>
            <v-icon small @click="deleteItemClick(item)">
              {{ icon.lineItemDelete }}
            </v-icon>
          </template>
        </v-data-table>
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="newItemClick">
                <v-icon>{{ icon.lineItemAdd }}</v-icon>
              </v-btn>
            </template>
            <span>New Measure Type</span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showEditorDialog" width="400" persistent>
      <MeasureTypeEditor
        :infoId="selectedItemId"
        :isDialogOpen="showEditorDialog"
        @close="editorCloseEvent"
        @update="editorUpdateEvent"
      />
    </v-dialog>
    <DialogUtil ref="dialogUtil" />
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import { icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import MeasureTypeEditor from '@/components/Setup/Service/MeasureTypeEditor'
export default {
  name: 'MeasureTypeList',
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  components: { MeasureTypeEditor },
  setup(props) {
    const dialogUtil = ref(null)
    const loading = ref(false)

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      infoList.value = []
      getMeasureTypeList()
    }

    const infoList = ref([])
    const selectedItemId = ref(null)
    const showEditorDialog = ref(false)

    const getMeasureTypeList = async () => {
      loading.value = true
      const rq = {}
      const rs = await host.measureType.list(rq)
      infoList.value = rs.InfoList
      loading.value = false
    }

    function editItemClick(item) {
      selectedItemId.value = item.MeasureTypeId
      showEditorDialog.value = true
    }

    function deleteItemClick(item) {
      dialogUtil.value
        .confirm({
          title: 'Please confirm',
          text: `Delete Measure Type ${item.Code}`
        })
        .then(() => performDeleteMeasureType(item))
        .catch(() => {
          return
        })
    }

    async function performDeleteMeasureType(item) {
      const rq = { InfoId: item.MeasureTypeId }
      const rs = await host.measureType.delete(rq)
      if (rs.IsSuccess) {
        getMeasureTypeList()
      } else {
        dialogUtil.value.error(rs.Message)
      }
    }

    function newItemClick() {
      selectedItemId.value = null
      showEditorDialog.value = true
    }

    const headers = [
      { value: 'Code', text: 'Code' },
      { value: 'Description', text: 'Description' },
      { value: 'SortOrder', text: 'Sort Order', align: 'right' },
      { value: 'LowValue', text: 'Lowest', align: 'right' },
      { value: 'HighValue', text: 'Highest', align: 'right' },
      { value: 'IsRequired', text: 'Required', align: 'center' },
      { value: 'Actions', text: 'Actions', sortable: false, width: 60 }
    ]

    const editorCloseEvent = () => {
      showEditorDialog.value = false
    }

    const editorUpdateEvent = () => {
      showEditorDialog.value = false
      getMeasureTypeList()
    }

    initDialog()

    return {
      dialogUtil,
      infoList,
      headers,
      showEditorDialog,
      selectedItemId,
      editItemClick,
      deleteItemClick,
      newItemClick,
      editorCloseEvent,
      editorUpdateEvent,
      icon,
      loading
    }
  }
}
</script>

<style lang="scss" scoped></style>
